<template>
    <div class="m-auto px-2 lg:px-8 pt-3 pb-5 ">
        <table class="w-full table-fixed text-sm relative border border-next-light-gray">
            <colgroup>
                <col class="w-[200px]"/>
                <col :span="monthDayIterator"/>
            </colgroup>
            <thead class="sticky bg-next-light-gray border border-next-light-gray"
            style="top:calc(var(--top-navigation-height))">
            <tr>
                <th :colspan="monthDayIterator + 2" class="border border-next-light-gray">
                    <div class="flex flex-col md:flex-row pt-4 items-center md:mb-4 gap-3">
                        <h1 class="font-bold text-lg md:text-3xl">Controllo timesheet</h1>
                        <MonthSwitcher v-model:date="date" class="w-full max-w-[14rem]"></MonthSwitcher>
                        <div class="flex justify-self-end">
                            <Field v-model="search" @update:modelValue="onSearch" :label-visible="false"
                                   placeholder="Cerca" type="text"></Field>
                        </div>
                    </div>
                </th>
            </tr>
            <tr>
                <th class="bg-white border border-next-gray-md-darker sticky">Utente</th>
                <th v-for="d in monthDayIterator" class="bg-white border border-next-gray-md-darker sticky"
                    :class="getDayClass(d)">
                    {{ d }}
                </th>
                <th class="bg-white border border-next-gray-md-darker sticky"></th>
            </tr>
            </thead>
            <tbody class="text-center">
            <tr v-if="!Object.keys(Matrix).length">
                <td :colspan="monthDayIterator + 2" class="border border-next-gray-md-darker text-center">Non sono
                    presenti timesheet registrati
                </td>
            </tr>
            <template v-else>
                <tr v-for="(r, i) in Matrix">
                    <td class="border border-next-gray-md-darker">{{ r['name'] }}</td>

                    <td v-for="d in monthDayIterator" class="border border-next-gray-md-darker"
                        :class="`${getHourCompletion(r['timesheet'][d + 1])} ${getDayClass(d)}`">
                        {{ timeToFormat(r['timesheet'][d + 1]?.totale_minuti) }}
                    </td>
                    <td class="border border-next-gray-md-darker font-bold">
                        {{
                            timeToFormat(r['timesheet'].reduce((acc, val) => acc + parseInt(val?.totale_minuti || 0), 0))
                        }}
                    </td>
                </tr>
                <tr>
                    <td class="border border-next-gray-md-darker">&nbsp;</td>

                    <td v-for="d in monthDayIterator" class="border border-next-gray-md-darker font-bold ">
                        {{ timeToFormat(totalMinutesPerDay(d + 1)) }}
                    </td>

                    <td class="border border-next-gray-md-darker font-bold"> {{
                            timeToFormat([...Array(monthDayIterator)].reduce((acc, d, idx) => acc + totalMinutesPerDay(idx), 0))
                        }}
                    </td>
                </tr>
            </template>
            </tbody>
        </table>

    </div>

</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import WeekSwitcher from "@/components/WeekSwitcher.vue";
import TimesheetTable from "@/components/Timesheet/TimesheetTable.vue";
import TimesheetTableMobile from "@/components/Timesheet/TimesheetTableMobile.vue";
import {Watch} from "vue-property-decorator/lib/decorators/Watch";
import timesheetManager from "@/api/Timesheet";
import moment from "moment/moment";
import Field from "@/components/Field.vue";
import Star from "@/components/Star.vue";
import MonthSwitcher from "@/components/MonthSwitcher.vue";

@Options({
    name: 'ControlloTimesheet',
    components: {
        Field,
        MonthSwitcher,
    },
    computed: {}
})
export default class ControlloTimesheet extends Vue {
    timer: any = 0
    loading = false
    date = ''
    search = ''
    records: any = []

    created() {
        this.date = moment().format('YYYY-MM')
    }

    get Matrix() {
        return this.records.reduce((acc: any, record: any) => {
            if (!acc[record.user_id]) {
                acc[record.user_id] = {name: record.user_name, timesheet: []}
            }
            acc[record.user_id]['timesheet'][moment(record.giorno).date() + 1] = record
            return acc
        }, {})
    }

    getDayClass(day: number) {
        const a = moment(this.date).set('date', day)
        return a.format('dddd')
    }

    getHourCompletion(record: any) {
        if (record && record.giorno && record.ore_lavorative > record.totale_ore) {
            return 'incomplete'
        }
        return ''
    }

    get monthDayIterator() {
        return moment(this.date).startOf('month').daysInMonth()
    }

    month() {
        return moment(this.date).startOf('month').clone()
    }

    minutesToDict(minute: number) {
        return {ore: Math.floor(minute / 60), minuti: minute % 60, minuti_totali: minute}
    }

    totalMinutesPerDay(day_idx: number) {
        let acc = 0
        for (let user_id in this.Matrix) {
            acc += parseInt(this.Matrix[user_id]['timesheet'][day_idx]?.totale_minuti) || 0
        }
        return acc
    }

    timeToFormat(minuti: number) {
        const dict = this.minutesToDict(minuti)
        if (dict.ore && dict.minuti) {
            return `${dict.ore}h ${dict.minuti}m`
        } else if (dict.ore) {
            return `${dict.ore}h`
        } else if (dict.minuti) {
            return `${dict.minuti}m`
        }
        return ''
    }

    @Watch('filterDate')
    onSearch() {
        clearTimeout(this.timer)
        this.timer = setTimeout(this.refresh, 500)
    }

    @Watch('date')
    refresh() {
        this.loading = true
        timesheetManager.monthlyResponsibleTimesheet({
            month: this.month().format('YYYY-MM'),
            search: this.search
        }).then((res: any) => {
            this.records = res.data.data
        }).finally(() => {
            this.loading = false
        })
    }
}
</script>


<style lang="scss">
th.domenica {
    color: var(--orange);
    width: 2%;
    min-width: 15px;
}

th.sabato {
    color: orange;
    width: 2%;
    min-width: 15px;
}

td.incomplete:not(.sabato, .domenica) {
    color: var(--orange);
}

td.sabato, td.domenica {
    background-color: var(--gray-md);
}
</style>
